var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pg-faq",attrs:{"id":"faq"}},[_c('h2',{staticClass:"h2 pg-faq__header"},[_vm._v("FAQs")]),_c('ul',{staticClass:"pg-faq__list"},_vm._l((_vm.FAQs),function(faq,index){return _c('p-g-faq',{key:index,attrs:{"faq":faq}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }